module.exports = __webpack_public_path__ + "static/media/favicon-stir.fa8933d1.ico";